require("dotenv").config(); //eslint-disable-line

const fr = require('./src/data/fr/index');
const en = require('./src/data/en/index');


module.exports = {
  attributes: { //  add html attributes in the firts node of the application node
    wave: { value: 1 },
    waveDebugger: { value: false },
    scroll_mode: { value: 'auto' }, // auto, smooth
    enable_countdowns: { value: false },
    analytics_id: { value: 'UA-XXXXXXXXX-X' },
    liberty_youtube_id: { value: 'gtffkrJhQy8' },
    equality_youtube_id: { value: '62GqunJTjXI' },
    fraternity_youtube_id: { value: 'oqhkNdDRgbA' },
    differ___loading: {
      value: true, // Loads the 3D textures after the initial rendering
    },
    skip___frame: {
      value: true, // Skips frames when FPS is low
    },
    render___stopauto: {
      value: true, // Stops the rendering after some time of inactivity
    },
    external___hosting: {
      // value: 'https://mdp-orsdefrance-031264155361.s3.eu-west-1.amazonaws.com/',
      value: 'https://d1q7738q8q4wel.cloudfront.net/',
    },
    // force___external: {
    //   value: 'true',
    // },

  },
  // data fr and en
  fr,
  en,
  statics: ['statics'], // copy the statics folder to the build output
};
